import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import moment from "moment";
import { MyUtils } from "../../../../services/my-utils.service";
import { DataMiningDialogData, DataMiningFormBuilder } from "./data-mining-form-builder";
import { DataMiningService } from "../../../../services/data-mining.service";
import { MatSelect } from "@angular/material/select";
import { Subject, takeUntil } from "rxjs";
interface RecoveryPlanDomain {
  elements: ContactReason[];
  errors: string[];
}

interface ContactReason {
  scope: string;
  level: number;
  id: number;
  father: number;
  ordinal: number;
  defaultDescription: string;
  children: ContactReason[];
}
@Component({
  selector: "app-cec-recovery-plan-dialog",
  templateUrl: "./cec-recovery-plan-dialog.component.html",
  styleUrls: ["./cec-recovery-plan-dialog.component.scss"],
})
export class CecRecoveryPlanDialogComponent implements OnInit, OnDestroy {
  @ViewChild("contactReasonSelect") contactReasonSelect!: MatSelect;
  @ViewChild("dissReasonSelect") dissReasonSelect!: MatSelect;
  @ViewChild("dissReasonSelect2") dissReasonSelect2!: MatSelect;
  isCreate: boolean = true;
  openInfo: boolean = false;
  file?: File;
  fileB64?: string;
  dataMiningFormBuilder: DataMiningFormBuilder;
  dissatisfactionReasons: ContactReason[] = [{ id: 0, children: [], father: 0, level: 0, ordinal: 0, scope: '', defaultDescription: '' }];
  dissatisfactionReasons2: ContactReason[] = [{ id: 0, children: [], father: 0, level: 0, ordinal: 0, scope: '', defaultDescription: '' }];
  contactReasons: ContactReason[] = [{ id: 0, children: [], father: 0, level: 0, ordinal: 0, scope: '', defaultDescription: '' }];
  currentContactsChild: ContactReason[] = [{ id: 0, children: [], father: 0, level: 0, ordinal: 0, scope: '', defaultDescription: '' }];
  currentDissChild: ContactReason[] = [{ id: 0, children: [], father: 0, level: 0, ordinal: 0, scope: '', defaultDescription: '' }];
  currentDissChild2: ContactReason[] = [{ id: 0, children: [], father: 0, level: 0, ordinal: 0, scope: '', defaultDescription: '' }];
  $destroy: Subject<void> = new Subject<void>();


  get form(): FormGroup {
    return this.dataMiningFormBuilder.form;
  }
  get additionalInformation(): FormArray {
    return (this.form.controls['additionalInformation'] as FormArray)
  }

  constructor(
    public utils: MyUtils,
    @Inject(MAT_DIALOG_DATA) public data: DataMiningDialogData,
    private dataMiningService: DataMiningService
  ) {
    this.dataMiningFormBuilder = new DataMiningFormBuilder(this.data, this.utils);
  }


  ngOnInit(): void {
    this.dataMiningService.getRecoveryPlanDomain().subscribe((res: RecoveryPlanDomain) => {
      this.contactReasons = res.elements.filter(cr => cr.scope === 'CONTACT_REASON');
      this.dissatisfactionReasons = res.elements.filter(cr => cr.scope === 'DISSATISFACTION_REASON');
      this.dissatisfactionReasons2 = res.elements.filter(cr => cr.scope === 'DISSATISFACTION_REASON');
      this.onSelectionChange();
      


    });
  }

  ngOnDestroy() {
    this.$destroy.next();
    this.$destroy.complete();
  }

  returnValue() {
    let data: any = {};
    let additionalInformation: any = [];
    data["additionalInformation"] = additionalInformation;
    this.createObject(data, this.form);
    if (this.file) { data.file = this.file }
    return data;
  }

  createObject(data: any, form: FormGroup) {
    Object.keys(form.value).forEach((key) => {
      data[key] = form.value[key];
    });
  }

  incomingfile(event: any) {
    this.file = event.target.files[0] as File;
  }

  deleteFile() {
    this.file = undefined;
    this.fileB64 = undefined;
  }

  get sizeError() {
    return this.file ? this.file.size > 16 * Math.pow(10, 6) : false;
  }

  parseDate(timestamp: number | string) {
    if (timestamp && timestamp !== "not valid" && timestamp !== "valid") {
      let date = new Date(timestamp);
      return moment(date).format('DD/MM/YYYY, hh:mm');
    } else {
      return "";
    }
  }

  downloadFile() {
    // this.recoveryPlanService.getRecoveryPlanAttach(this.data.brand!, this.data.region!, this.data.recoveryPlanId!).subscribe(data => {
    // })
  }

  onSelectionChange() {
    (this.form.controls['contactReason'] as FormGroup).controls['categoryLevel1']
      .valueChanges
      .pipe(takeUntil(this.$destroy))
      .subscribe(value => {
        (this.form.controls['contactReason'] as FormGroup).controls['categoryLevel2'].enable();
        (this.form.controls['contactReason'] as FormGroup).controls['categoryLevel2'].reset();
        this.currentContactsChild = this.contactReasons.find(reason => reason.id == value)?.children ?? [];
      });

    (this.form.controls['dissatisfactionReason1'] as FormGroup).controls['categoryLevel1']
      .valueChanges
      .pipe(takeUntil(this.$destroy))
      .subscribe(value => {
        (this.form.controls['dissatisfactionReason1'] as FormGroup).controls['categoryLevel2'].enable();
        (this.form.controls['dissatisfactionReason1'] as FormGroup).controls['categoryLevel2'].reset();
        this.currentDissChild = this.dissatisfactionReasons.find(reason => reason.id == value)?.children ?? [];
      });

    (this.form.controls['dissatisfactionReason2'] as FormGroup).controls['categoryLevel1']
      .valueChanges
      .pipe(takeUntil(this.$destroy))
      .subscribe(value => {
        (this.form.controls['dissatisfactionReason2'] as FormGroup).controls['categoryLevel2'].enable();
        (this.form.controls['dissatisfactionReason2'] as FormGroup).controls['categoryLevel2'].reset();
        this.currentDissChild2 = this.dissatisfactionReasons2.find(reason => reason.id == value)?.children ?? [];
      });
  }
}
